import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueCookie from 'vue-cookie'
import api from '@/api'
import Element from 'element-ui';
import { Message } from 'element-ui'
import dayjs from "dayjs"
import 'element-ui/lib/theme-chalk/index.css';
import Antd from 'ant-design-vue';
import BaiduMap from 'vue-baidu-map'
import 'ant-design-vue/dist/antd.css';
// 自定义修改antd组件默认样式
import './assets/antd.css'
import tracker from './tracker'
tracker.install(Vue)
Vue.config.productionTip = false;
Vue.use(Antd);

Vue.use(BaiduMap, {
  /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
  ak: 'Y5NuypCulukvKc5UGlerfnyhcFzfnwYU'
})

// 页面全局样式
import "@/assets/scss/style.scss";
import * as VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp)
Vue.config.productionTip = false;
Vue.use(Element, { size: 'small', zIndex: 3000 });
Vue.use(VueCookie)
// 挂载全局
Vue.prototype.$api= api // ajax请求方法
Vue.prototype.$day = dayjs;//可以全局使用dayjs
Vue.prototype.$message = Message
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
